<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditRoles" native-type="button" type="success" class="float-right" @click="$modal.show('create_role')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th>{{ $t('Permissions') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(role, i) in roles" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ role.name }}</td>
                    <td>{{ role.permissions && role.permissions.length }}</td>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button v-if="$store.getters.canEditRoles" native-type="button" @click="$modal.show('update_permissions', {role})" small>
                                {{ $t('Edit permissions') }}
                            </app-button>
                            <app-button v-if="$store.getters.canEditRoles" native-type="button" @click="$modal.show('update_role', {role})" small>
                                {{ $t('Edit') }}
                            </app-button>
                            <app-button v-if="$store.getters.canDeleteRoles" native-type="button" type="danger" @click="destroy(role.id)" small>
                                {{ $t('Delete') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <create-modal @setRole="setRole"/>
        <update-permissions-modal @setRole="setRole"/>
        <update-modal @setRole="setRole"/>
    </div>
</template>

<script>
import RoleService from '@services/role.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import UpdatePermissionsModal from './modals/UpdatePermissions';
import {mapGetters} from 'vuex';
import Vue from 'vue';

export default {
    data() {
        return {
            roles: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getRoles() {
            RoleService.roles().then(res => this.roles = res);
        },
        setRole(role) {
            const index = this.roles.findIndex(r => r.id === role.id);
            if (index !== -1) {
                Vue.set(this.roles, index, role);
            } else {
                this.roles.push(role);
            }
        },
        destroy(roleId) {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            RoleService.destroy(roleId).then(res => {
                const index = this.roles.findIndex(r => r.id === roleId);
                this.roles.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal,
        UpdatePermissionsModal
    },
    created() {
        this.getRoles();
    },
    metaInfo() {
        return {
            title: this.$t('Roles')
        };
    }
};
</script>
